import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'utils/dayjs';
import {Box, Button, Flex, Heading, Icon, Text} from '@spothero/ui';
import DateUtils from 'utils/date';
import QuickFilters from 'common/search-filters-controls/QuickFilters';
import IconSearch from '@spothero/icons/search';
import Config from 'config';
import SegmentUtils from 'utils/segment';
import SearchTransientInOutFilter from 'pages/search-transient-event-monthly/components/search-transient-inout-filter';

const spotListSearchControlsCondensedInfoStyleProps = {
    marginRight: {base: 2, desktop: 4},
    overflowX: 'hidden',
    transform: 'translate3d(0, 0, 0)',
    flexGrow: 1,
};

const condensedInfoHeadingStyleProps = {
    as: 'h3',
    fontSize: {base: 'xs', desktop: 'sm'},
    marginBottom: 1,
    color: 'text.secondary.light',
    fontWeight: 'semibold',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

const condensedInfoTextStyleProps = {
    fontSize: {base: 'sm', desktop: 'base'},
    display: 'inline-block',
    width: '100%',
    fontWeight: 'semibold',
    textOverflow: 'ellipsis',
    color: 'text.primary.light',
};

const condensedEditButtonStyleProps = {
    alignSelf: 'center',
    paddingX: 2,
    as: 'span',
    fontWeight: 'semibold',
};

const SpotListSearchControlsCondensed = ({
    starts,
    ends,
    isMonthly,
    title,
    onEditClick: onEditClickProp,
    parkingType,
}) => {
    const dateTimeFormatted = DateUtils.getDateTimeSummary({
        startDateTimeObj: dayjs(starts),
        endDateTimeObj: dayjs(ends),
        isMonthly,
    });
    const dateTime = isMonthly
        ? `Starting ${dateTimeFormatted}`
        : dateTimeFormatted;

    const onEditClick = e => {
        SegmentUtils.track({
            event: 'Search Edit Button Clicked',
            properties: {
                /* eslint-disable camelcase */
                parking_type: parkingType,
                client: Config.isMobile ? 'mobile-web' : 'web',
                /* eslint-enable camelcase */
            },
        });
        onEditClickProp(e);
    };

    return (
        <Box
            className="SpotListSearchControlsCondensed"
            flexDirection="column"
            backgroundColor="background.gray"
            paddingBottom="3"
            sx={{
                '.QuickFilters': {
                    paddingX: 0,
                    paddingTop: 3,
                    paddingBottom: 0,
                },
            }}
        >
            <Button onClick={onEditClick} textAlign="left" variant="tertiary">
                <Flex
                    backgroundColor="white"
                    borderRadius="10"
                    paddingX="6"
                    paddingY="2.5"
                    width="100%"
                    borderColor="accent"
                    borderWidth="1px"
                    borderStyle="solid"
                >
                    <Box {...spotListSearchControlsCondensedInfoStyleProps}>
                        <Heading {...condensedInfoHeadingStyleProps}>
                            {title}
                        </Heading>
                        <Text {...condensedInfoTextStyleProps}>{dateTime}</Text>
                    </Box>
                    <Flex {...condensedEditButtonStyleProps}>
                        <Icon
                            as={IconSearch}
                            paddingRight="1"
                            display="inline-block"
                        />
                        Edit
                    </Flex>
                </Flex>
            </Button>
            <QuickFilters
                showReservationTypes={isMonthly}
                isCondensed
                visibleSlugs={['self-park']}
                extraFilterSlot={
                    isMonthly ? null : <SearchTransientInOutFilter />
                }
            />
        </Box>
    );
};

SpotListSearchControlsCondensed.propTypes = {
    parkingType: PropTypes.string.isRequired,
    starts: PropTypes.string.isRequired,
    ends: PropTypes.string,
    isMonthly: PropTypes.bool,
    title: PropTypes.string,
    onEditClick: PropTypes.func,
};

export default SpotListSearchControlsCondensed;
